export const NAVBAR_ITEMS = [
  {
    title: "Home",
    isLoginPage: true,
    isSignupPage: true,
    isHomepage: true,
    to: "/",
  },
  {
    title: "Agri Robots",
    isLoginPage: false,
    isSignupPage: false,
    isHomepage: true,
    to: "/agri-robots",
  },
  // {
  //   title: "Products",
  //   isLoginPage: false,
  //   isSignupPage: false,
  //   isHomepage: true,
  //   to: "/products",
  // },
  // {
  //   title: "Physical AI",
  //   isLoginPage: false,
  //   isSignupPage: false,
  //   isHomepage: true,
  //   to: "/physical-ai",
  // },
  
  {
    title: "Other usecases",
    isLoginPage: false,
    isSignupPage: false,
    isHomepage: true,
    to: "/service-robots",
  },
  {
    title: "About Us",
    isLoginPage: true,
    isSignupPage: true,
    isHomepage: true,
    to: "/about",
  },
  {
    title: "Contact Us",
    isLoginPage: true,
    isSignupPage: true,
    isHomepage: true,
    to: "/contact",
  },
  {
    title: "Login",
    isLoginPage: false,
    isSignupPage: true,
    isHomepage: false,
    to: "/login",
  },
  {
    title: "Sign Up",
    isLoginPage: true,
    isSignupPage: false,
    isHomepage: false,
    to: "/signup",
  },
];
